/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrgQueryResult model module.
 * @module model/OrgQueryResult
 * @version 1.0
 */
class OrgQueryResult {
    /**
     * Constructs a new <code>OrgQueryResult</code>.
     * @alias module:model/OrgQueryResult
     */
    constructor() { 
        
        OrgQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrgQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrgQueryResult} obj Optional instance to populate.
     * @return {module:model/OrgQueryResult} The populated <code>OrgQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrgQueryResult();

            if (data.hasOwnProperty('abbv')) {
                obj['abbv'] = ApiClient.convertToType(data['abbv'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('defaultLangCode')) {
                obj['defaultLangCode'] = ApiClient.convertToType(data['defaultLangCode'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('maxMcPlayPerDay')) {
                obj['maxMcPlayPerDay'] = ApiClient.convertToType(data['maxMcPlayPerDay'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} abbv
 */
OrgQueryResult.prototype['abbv'] = undefined;

/**
 * @member {String} address
 */
OrgQueryResult.prototype['address'] = undefined;

/**
 * @member {String} createdAt
 */
OrgQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} defaultLangCode
 */
OrgQueryResult.prototype['defaultLangCode'] = undefined;

/**
 * @member {String} deletedAt
 */
OrgQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
OrgQueryResult.prototype['id'] = undefined;

/**
 * @member {Number} maxMcPlayPerDay
 */
OrgQueryResult.prototype['maxMcPlayPerDay'] = undefined;

/**
 * @member {String} name
 */
OrgQueryResult.prototype['name'] = undefined;

/**
 * @member {String} updatedAt
 */
OrgQueryResult.prototype['updatedAt'] = undefined;






export default OrgQueryResult;

